<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import AcademicYearServices from "@/services/api/publicPortal.api";
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document'

export default {
  name: "TherapyEvaluationQuestionaireVue",
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({    
    model: {
     search: {
       collections: {
         academicYears: [],
         scholarSemesters: [],
         reportTypes: []
       },
       filters: {
         academicYear: null,
         scholarSemester: null,
         reportType: null         
       },
     }
    }
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Cuestionario de Satisfacción de Servicios Terapia y Evaluación',
        icon:
          'fas fa-file-invoice',
        routes: ['Informes', 'Cuestionario de Satisfacción de Servicios Terapia y Evaluación'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,                  
        },
        {
          name: 'scholarSemester',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Semestre:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un semestre.',
          validations: 'required',
          class: 'col-12 col-md-3',
          clearable: false,
          options: this.model.search.collections.scholarSemesters,
          value: this.model.search.filters.scholarSemester,          
        },
        {
          name: 'reportType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Reporte:',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          disabled: this.isSemesterSelected,
          clearable: true,
          options: this.model.search.collections.reportTypes,
          value: this.model.search.filters.reportType,
        }
      ]
    },
    isSemesterSelected() {
      return !this.model.search.filters.scholarSemester
    }
  },
  async mounted() {
    const { data } = await AcademicYearServices.initFilterstherapyevaluationquestionaire();
    this.model.search.collections.academicYears = data.academicYearList;
    this.model.search.collections.scholarSemesters = data.semesterList;
    this.model.search.collections.reportTypes = data.reportTypeList;
    this.model.search.filters.academicYear = this.model.search.collections.academicYearList[0];
    this.model.search.filters.scholarSemester = null;
    this.model.search.filters.reportType = null;
  },
  methods: {
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      await ReportServices.getReport('therapyevaluationquestionaire', {
        academicYearId: this.model.search.filters.academicYear?.id,
        semester: this.model.search.filters.scholarSemester?.id,
        reportType: this.model.search.filters.reportType?.id
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
}
</script>